export const isProduction = true;
export const googlemapsapikey = 'AIzaSyDT8u2W9mcuJ-uESWb9ZAcd6sd6hkmAMVs';
export const environment = Object.freeze({
  production: true,
  homolog: true,
  brand: 'fr',

  baseUrl: 'https://services.homolog.formula.bodytech.company:8002/api',
  portal: 'https://homolog.formula.bodytech.company/api',

  services: {
    baseUrl: 'https://services.homolog.formula.bodytech.company',
    evoBaseUrl: 'https://evo-integracao.w12app.com.br',
  },

  sentry: {
    dsn: 'https://bccd2cb9c4544cef9cf2a1bb6bd86475@sentry.dev.bodytech.company/10',
    enabled: true,
    environment: 'homolog',
    release: 'bo-frportal-__SENTRY_RELEASE__',
    attachStacktrace: true,
  },

  recaptchaKey: '',

  s3buckets: {
    images: 'https://images.homolog.formula.bodytech.company',
    medias: 'https://medias.homolog.formula.bodytech.company',
    terms: 'https://terms.homolog.formula.bodytech.company'
  },

  s3Region: 'us-east-1',
  s3Environment: 'homolog.formula.bodytech.company'

});
